<template>
  <div v-if="deliveryNo" class="panel-body">
    <div class="box-delivery-name m-b-md">
      <div class="row">
        <div class="col-md-2 col-lg-1 w-150">
          <div class="delivery-name"><strong>納品名</strong></div>
        </div>
        <div class="col-md-10 col-lg-7">
          <input type="text" :class="['form-control', deliveryName ? '' : 'bg-no-input']" v-model.trim="deliveryName">
          <div>※セールモンスターのみが使用する項目です。セラー様が管理しやすい名称をご入力ください。</div>
          <div v-if="validateErrors.deliveryName.length" class="text-red"><b>{{ validateErrors.deliveryName[0]}}</b></div>
        </div>
      </div>
    </div>
    <div class="box-delivery-date m-b-md">
      <div class="row">
        <div class="col-md-2 col-lg-1 w-150">
          <div class="delivery-date"><strong>納品予定日</strong></div>
        </div>
        <div class="col-md-10 col-lg-6">
          <date-picker
            v-model="deliveryDate"
            placeholder=""
            ref="datepickerStart"
            format="YYYY/MM/DD"
            :input-attr="{id: 'delivery-date'}"
            :lang="lang"
            :not-before="todayFormatDate"
            :input-class="['mx-input', (deliveryDate) ? '' : 'bg-no-input']"
          ></date-picker>
          <div v-if="validateErrors.deliveryDate.length" class="text-red"><b>{{ validateErrors.deliveryDate[0]}}</b></div>
        </div>
      </div>
    </div>
    <div class="box-origin-info-default m-b-sm">
      <div class="row">
        <div class="col-md-2 col-lg-1 w-150">
          <div class="m-b-sm"><strong>発送元情報</strong></div>
        </div>
        <div class="col-md-9 col-lg-10">
          <div v-if="deliverySellerInfo" class="delivery-info-default">
            <div>{{ deliverySellerInfo.name }}</div>
            <div>
              {{ deliverySellerInfo.postalCode }} &nbsp;&nbsp;&nbsp; {{ deliverySellerInfo.address }}
            </div>
            <div>{{ deliverySellerInfo.phoneNo }}</div>
          </div>
          <a href="javascript:void(0)" class="text--underline" @click.prevent="openModalDeliveryInfo()">登録・変更はこちら</a>
          <div v-if="validateErrors.deliveryInfo.length" class="text-red"><b>{{ validateErrors.deliveryInfo[0]}}</b></div>
        </div>
      </div>
    </div>
    <div class="box-btn-selection-product">
      <button type="button" class="btn btn-primary custom-btn-delivery" @click.prevent="openModalDeliveryProductAdd()">商品選択</button>
    </div>
    <div class="box-selected-products m-t-lg m-b-lg">
      <div v-if="!deliverySelectedProducts.length" class="empty-products text-center">
        <h3 class="m-b-xl"><strong>商品選択より、納品する商品を選択してください。</strong></h3>
        <router-link class="btn btn-basic m-b-xl" :to="{name: 'Delivery Requests', params: {tab: 'delivery-request-list'}}">一覧へ戻る</router-link>
      </div>
      <div v-else>
        <div class="m-b-md">
          納品依頼登録をするためには、納品予定数を入力後に登録ボタンを押してしてください。
        </div>
        <div class="list-products">
          <div class="selected-products-header"></div>
          <div class="table-selected-products">
            <table class="table">
              <thead>
                <tr>
                  <th class="w-120" style="text-align: center;">納品する商品</th>
                  <th class="item-name-head"></th>
                  <th class="w-120 item-quantity-head">納品予定数</th>
                  <th class="w-220 item-fnsku-head p-l-24">
                    <fnsku-kbn-thead />
                  </th>
                  <th class="w-200 item-good-label-attachkbn-head p-l-24">
                    <goods-label-thead />
                  </th>
                  <th class="w-200 expiration-date-head p-l-24">
                    <due-date-management-thead />
                  </th>
                  <th class="w-220 shipping-packing-head">
                    <shipping-packing-thead />
                  </th>
                  <th class="w-100" style="text-align: center;">操作</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(deliverySelectedProduct, deliverySelectedProductIndex) in deliverySelectedProducts" :key="deliverySelectedProductIndex">
                  <td class="text-center">
                    <div class="box-selected-product-image w-40">
                      <img :src="deliverySelectedProduct.image" alt="" class="selected-product-image img-responsive">
                    </div>
                    <div :class="`box-delivery-judgment-status ${getJudgmentStatusClass(deliverySelectedProduct.status)}`">{{ deliverySelectedProduct.status_str }}</div>
                  </td>
                  <td>
                    <div class="m-b-xs">{{ deliverySelectedProduct.itemName }}</div>
                    <div>{{ deliverySelectedProduct.asin }}</div>
                  </td>
                  <td class="td-vertical-top">
                    <div class="h-30"></div>
                    <input type="text" class="form-control expected-delivery-number text-right" :class="parseInt(deliverySelectedProduct.quantity) ? '' : 'bg-no-input'" v-model="deliverySelectedProduct.quantity">
                    <div v-if="validateErrors.quantity[deliverySelectedProduct.asin] && validateErrors.quantity[deliverySelectedProduct.asin].length" class="text-red"><b>{{ validateErrors.quantity[deliverySelectedProduct.asin][0]}}</b></div>
                  </td>
                  <td class="fnsku-kbn-td td-vertical-top p-l-24">
                    <fnsku-kbn-item
                      :product="deliverySelectedProduct"
                      :isEdit="true"
                    />
                  </td>
                  <td colspan="3" class="td-vertical-top">
                    <div class="box-colspan">
                      <div class="box-product-label-attach-kbn w-200 p-l-16">
                        <div class="h-30"></div>
                        <goods-label-attach-kbn-item
                          :product="deliverySelectedProduct"
                        />
                      </div>
                      <div class="box-due-date-manage w-200 p-l-24">
                        <due-date-management-item
                          :key="`due-date-manage-${deliverySelectedProduct.asin}`"
                          :product="deliverySelectedProduct"
                        />
                        <div v-if="validateErrors.dueDateManagement[deliverySelectedProduct.asin] && validateErrors.dueDateManagement[deliverySelectedProduct.asin].length" class="text-red"><b>{{ validateErrors.dueDateManagement[deliverySelectedProduct.asin][0]}}</b></div>
                      </div>
                      <div class="box-shipping-packing w-220 p-l-8">
                        <div class="h-30"></div>
                        <shipping-packing-item
                          :key="`shipping-packing-${deliverySelectedProduct.asin}`"
                          :product="deliverySelectedProduct"
                          :isEdit="true"
                        />
                      </div>
                    </div>
                    <div :class="[getAvailabilityDate(deliverySelectedProduct) ? '' : 'availability-date-visibility']" class="m-t-xs availability-date p-l-16">
                      出荷可能期限日：{{ getAvailabilityDate(deliverySelectedProduct) }}までの注文に対して出荷することができます。
                    </div>
                  </td>
                  <td class="td-vertical-top text-center">
                    <div class="h-30"></div>
                    <button type="button" class="btn btn-delete-selected-product" @click.prevent="deleteDeliverySelectedProduct(deliverySelectedProduct)">削除</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="text-center m-b-md">
          <router-link class="btn btn-basic m-r-sm" :to="{name: 'Delivery Requests', params: {tab: 'delivery-request-list'}}">一覧へ戻る</router-link>
          <button type="button" class="btn btn-primary custom-btn-delivery" @click.prevent="submitValidate()">登録</button>
        </div>
      </div>
    </div>

    <delivery-info-modal
      v-if="openDeliveryInfoModal"
      ref="deliveryInfoModal"
      @close="closeModalDeliveryInfo"
      @openModalRegisterDeliveryInfo="openModalRegisterDeliveryInfo"
      @setDefaultInfoSuccess="setDeliverySellerInfo"
    />
    <!-- Modal create and edit delivery info -->
    <register-delivery-info-modal
      v-if="openRegisterDeliveryInfoModal"
      ref="registerDeliveryInfoModal"
      @close="closeModalRegisterDeliveryInfo"
      @updatedDeliveryInfo="updatedDeliveryInfo"
    />
    <delivery-product-add
      v-if="openDeliveryProductAddModal"
      ref="deliveryProductAddModal"
      :deliverySelectedProducts="selectedProducts"
      @close="closeModalDeliveryProductAdd"
      @handleSelectedProduct="handleDeliverySelectedProduct"
      @handleSelectedProducts="handleDeliverySelectedProducts"
    />
    <!-- Modal confirm delivery products register -->
    <modal-confirm
      v-if="openDeliveryProductsAddConfirmModal"
      :message="deliveryProductsAddConfirmMessage"
      @confirm="deliveryProductsAdd"
      @close="closeModalConfirmDeliveryProductsAdd"
    />
    <!-- Modal alert added delivery products -->
    <modal-alert
      v-if="openAlertDeliveryProductsAddedModal"
      :message="alertDeliveryProductsAddedMessage"
      :customHide="true"
      :modalWidth="550"
      @close="closeModalAlertProductsAdded"
    />
    <!-- Modal alert validate fails -->
    <modal-alert
      v-if="openAlertValidateFailsModal"
      :message="alertValidateFailsMessage"
      :customHide="true"
      @close="closeModalAlertValidateFails"
    />
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import DeliveryInfoModal from '@/view/deliveryRequests/components/DeliveryInfoModal'
import RegisterDeliveryInfoModal from '@/view/deliveryRequests/components/RegisterDeliveryInfoModal'
import DeliveryProductAdd from '@/view/deliveryRequests/components/DeliveryProductAdd'
import ModalConfirm from '@/components/ModalConfirm'
import ModalAlert from '@/components/ModalAlert'
import DueDateManagementItem from '@/view/deliveryRequests/components/DueDateManagementItem'
import store from '@/store'
import DeliveryInfoSellerService from '@/services/deliveryinfosellerservice'
import DeliveryService from '@/services/deliveryservice'
import LoadingBlock from '@/components/LoadingBlock'
import moment from 'moment'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'
import FnskuKbnItem from '@/view/deliveryRequests/components/FnskuKbnItem'
import GoodsLabelAttachKbnItem from '@/view/deliveryRequests/components/GoodsLabelAttachKbnItem'
import FnskuKbnThead from '@/view/deliveryRequests/components/FnskuKbnThead'
import GoodsLabelThead from '@/view/deliveryRequests/components/GoodsLabelThead'
import DueDateManagementThead from '@/view/deliveryRequests/components/DueDateManagementThead'
import ShippingPackingThead from '@/view/deliveryRequests/components/ShippingPackingThead'
import ShippingPackingItem from '@/view/deliveryRequests/components/ShippingPackingItem'

export default {
  components: {
    DatePicker,
    DeliveryInfoModal,
    RegisterDeliveryInfoModal,
    DeliveryProductAdd,
    ModalConfirm,
    ModalAlert,
    LoadingBlock,
    DueDateManagementItem,
    FnskuKbnItem,
    GoodsLabelAttachKbnItem,
    FnskuKbnThead,
    GoodsLabelThead,
    DueDateManagementThead,
    ShippingPackingThead,
    ShippingPackingItem
  },
  data () {
    return {
      openDeliveryInfoModal: false,
      openRegisterDeliveryInfoModal: false,
      openDeliveryProductAddModal: false,
      openDeliveryProductsAddConfirmModal: false,
      openAlertDeliveryProductsAddedModal: false,
      openAlertValidateFailsModal: false,
      deliveryNo: null,
      deliveryName: null,
      deliveryDate: null,
      lang: {
        days: ['日', '月', '火', '水', '木', '金', '土'],
        months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
        pickers: ['1週間後', '1ヶ月後', '1週間前', '1ヶ月前'],
        placeholder: {
          date: '日付を選択',
          dateRange: '期間を選択'
        }
      },
      loader: null,
      deliverySellerInfo: null,
      selectedProducts: [],
      validateErrors: {
        deliveryName: [],
        deliveryDate: [],
        deliveryInfo: [],
        quantity: {},
        dueDateManagement: {}
      },
      isValidateFails: false
    }
  },
  created () {
    this.fetchDeliveryInfo()
    this.getDeliveryRequest()
  },
  computed: {
    deliveryProductsAddConfirmMessage () {
      return '納品情報を登録します。よろしいですか？'
    },
    alertDeliveryProductsAddedMessage () {
      return `
        <p>納品情報を登録しました。</p>
        <p>納品ラベル、商品ラベルが印刷可能になった際にメールでご連絡します。<br>しばらくお待ちください。</p>
        <p>納品管理番号：${this.deliveryNo}</p> <br>
        <div>
          セルモン倉庫商品に対する受取金額の設定をご確認ください。<br>
          <a class="text--underline" href="/products-new/list">受取金額の確認・変更はこちら</a>
        </div>
      `
    },
    deliverySelectedProducts () {
      return this.sortAscProductsByAsin(this.selectedProducts)
    },
    todayFormatDate () {
      return moment().format('YYYY/MM/DD')
    },
    getAvailabilityDate () {
      return product => {
        let availabilityDate = ''
        let expirationDate = product.expirationDate
        if (!expirationDate) {
          return availabilityDate
        }
        let minusDate = product.yamatoShippingNgPeriod
        let newDate = new Date(expirationDate)
        newDate.setDate(newDate.getDate() - minusDate)
        availabilityDate = moment(newDate).format('YYYY/MM/DD')

        return availabilityDate
      }
    },
    alertValidateFailsMessage () {
      return `入力エラーです。<br/>入力内容を確認、修正後にご登録をお願いします。`
    }
  },
  methods: {
    sortAscProductsByAsin (products) {
      products.sort((a, b) => {
        let fa = a.asin.toLowerCase()
        let fb = b.asin.toLowerCase()
        if (fa < fb) {
          return -1
        }
        if (fa > fb) {
          return 1
        }
        return 0
      })

      return products
    },
    getJudgmentStatusClass (judgmentStatusCode) {
      let classes = ''
      let statusSuccess = ['2']
      let statusWarning = ['0', '1']
      let statusDanger = ['8', '9']
      if (statusSuccess.includes(judgmentStatusCode)) {
        classes = 'judgment-status-success'
      } else if (statusWarning.includes(judgmentStatusCode)) {
        classes = 'judgment-status-warning'
      } else if (statusDanger.includes(judgmentStatusCode)) {
        classes = 'judgment-status-danger'
      }
      return classes
    },
    formatDate (value) {
      return value ? moment(value).format('YYYY/MM/DD') : ''
    },
    openModalDeliveryInfo (fromAfterUpdate = false) {
      this.openDeliveryInfoModal = true
      if (!fromAfterUpdate) {
        let logParams = {
          name: eventCode.delivery_requests.delivery_request_registration_tab.delivery_info.click_register_or_change_button,
          properties: {}
        }
        EventService.postTrackLog(logParams)
      }
    },
    closeModalDeliveryInfo () {
      $('#delivery-info-modal').modal('hide')
      this.openDeliveryInfoModal = false
    },
    openModalRegisterDeliveryInfo () {
      this.closeModalDeliveryInfo()
      this.openRegisterDeliveryInfoModal = true
    },
    closeModalRegisterDeliveryInfo () {
      $('#register-delivery-info-modal').modal('hide')
      this.openRegisterDeliveryInfoModal = false
    },
    openModalDeliveryProductAdd () {
      this.openDeliveryProductAddModal = true

      let logParams = {
        name: eventCode.delivery_requests.delivery_request_registration_tab.click_register_product,
        properties: {}
      }
      EventService.postTrackLog(logParams)
    },
    closeModalDeliveryProductAdd () {
      $('#delivery-product-add-modal').modal('hide')
      this.openDeliveryProductAddModal = false
    },
    openModalConfirmDeliveryProductsAdd () {
      if (this.isValidateFails) return
      this.openDeliveryProductsAddConfirmModal = true
    },
    closeModalConfirmDeliveryProductsAdd () {
      $('#confirm-alert').modal('hide')
      this.openDeliveryProductsAddConfirmModal = false
    },
    openModalAlertProductsAdded () {
      this.openAlertDeliveryProductsAddedModal = true
    },
    closeModalAlertProductsAdded () {
      $('#myModal').modal('hide')
      this.openAlertDeliveryProductsAddedModal = false
      this.deliveryDate = null
      this.deliveryName = null
      this.deliveryNo = null
      this.$router.push({
        name: 'Delivery Requests',
        params: {
          tab: 'delivery-request-list'
        },
        query: {
          action: 'refresh'
        }
      })
    },
    openModalAlertValidateFails () {
      this.openAlertValidateFailsModal = true
    },
    closeModalAlertValidateFails () {
      $('#myModal').modal('hide')
      this.openAlertValidateFailsModal = false
    },
    updatedDeliveryInfo () {
      let fromAfterUpdate = true
      this.openModalDeliveryInfo(fromAfterUpdate)
    },
    fetchDeliveryInfo () {
      DeliveryInfoSellerService.fetchDeliveryInfo()
        .then((response) => {
          store.commit('setDeliveryInfoItems', response.data)
        })
        .catch((error) => {
          store.commit('toggleModal', {
            show: true,
            message: error
          })
        })
    },
    handleDeliverySelectedProduct (product) {
      this.selectedProducts.push(product)
    },
    handleDeliverySelectedProducts (products) {
      this.selectedProducts = [...this.selectedProducts, ...products]
    },
    deliveryProductsAdd () {
      if (this.isValidateFails) return
      this.loader = this.$loading.show()

      this.selectedProducts.forEach(product => {
        let fnskuKbn = product.fnskuKbn
        if (!fnskuKbn) {
          product.fnsku = null
        }
      })

      let params = {
        deliveryNo: this.deliveryNo,
        deliveryName: this.deliveryName,
        deliveryDate: this.formatDate(this.deliveryDate),
        deliveryInfo: this.deliverySellerInfo,
        deliveryGoods: this.selectedProducts
      }
      DeliveryService.register(params)
        .then((response) => {
          this.closeModalConfirmDeliveryProductsAdd()
          this.openModalAlertProductsAdded()
          this.loader && this.loader.hide()

          let logParams = {
            name: eventCode.delivery_requests.delivery_request_registration_tab.click_register_product_button,
            properties: {
              deliveryNo: response.data.deliveryNo
            }
          }
          EventService.postTrackLog(logParams)
        })
        .catch((error) => {
          this.loader && this.loader.hide()
          store.commit('toggleModal', {
            show: true,
            message: error
          })
        })
    },
    deleteDeliverySelectedProduct (product) {
      this.selectedProducts = this.selectedProducts.filter(item => item.asin !== product.asin)
    },
    setDeliverySellerInfo (data) {
      if (data) {
        this.deliverySellerInfo = {
          name: data.name,
          address: data.address,
          phoneNo: data.phoneNo,
          postalCode: data.postalCode
        }
      }
    },
    getDeliveryRequest () {
      let routeValue = this.$route
      let deliveryNo = routeValue.query.deliveryNo ? routeValue.query.deliveryNo : null
      this.loader = this.$loading.show()
      let params = {
        deliveryNo: deliveryNo
      }
      DeliveryService.getDeliveryRequest(params)
        .then((response) => {
          this.loader && this.loader.hide()
          let deliveryRequest = response.data

          this.deliveryNo = deliveryRequest.deliveryNo
          this.deliveryName = deliveryRequest.deliveryName
          this.deliveryDate = deliveryRequest.deliveryDate

          this.deliverySellerInfo = {
            address: deliveryRequest.fromAddress,
            name: deliveryRequest.fromName,
            phoneNo: deliveryRequest.fromPhoneNo,
            postalCode: deliveryRequest.fromPostalCode
          }

          this.selectedProducts = deliveryRequest.goods
        })
        .catch((error) => {
          this.loader && this.loader.hide()
          this.$store.commit('toggleModal', {
            show: true,
            message: error
          })
        })
    },
    submitValidate () {
      let required = '※必ず入力してください'
      let number = '※半角数値で入力してください'
      if (!this.deliveryName || !this.deliveryName.trim()) {
        this.validateErrors.deliveryName.push(required)
      } else {
        this.validateErrors.deliveryName = []
      }
      if (!this.deliveryDate) {
        this.validateErrors.deliveryDate.push(required)
      } else {
        this.validateErrors.deliveryDate = []
      }
      if (!this.deliverySellerInfo || !Object.keys(this.deliverySellerInfo).length) {
        this.validateErrors.deliveryInfo.push(required)
      } else {
        this.validateErrors.deliveryInfo = []
      }
      this.selectedProducts.forEach((product) => {
        let quantity = parseInt(product.quantity)
        let asin = product.asin
        let isQuantityNaN = (product.quantity !== '' && product.quantity !== null) ? isNaN(product.quantity) : false
        this.validateErrors.quantity[asin] = []
        this.validateErrors.dueDateManagement[asin] = []
        if (isQuantityNaN) {
          this.validateErrors.quantity[asin][0] = number
        } else if (!isQuantityNaN && !quantity) {
          this.validateErrors.quantity[asin][0] = required
        } else {
          delete this.validateErrors.quantity[asin]
        }

        if (!product.expirationDate && product.dueDateManageFlg) {
          this.validateErrors.dueDateManagement[asin][0] = required
        } else {
          delete this.validateErrors.dueDateManagement[asin]
        }
      })

      for (let validateKey in this.validateErrors) {
        var item = this.validateErrors[validateKey]
        if (['quantity', 'dueDateManagement'].includes(validateKey)) {
          if (Object.keys(item).length) {
            this.isValidateFails = true
            break
          } else {
            this.isValidateFails = false
          }
        } else {
          if (item.length) {
            this.isValidateFails = true
            break
          } else {
            this.isValidateFails = true
          }
        }
      }

      if (this.isValidateFails) {
        this.openModalAlertValidateFails()
      } else {
        this.openModalConfirmDeliveryProductsAdd()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/deliveryRequests/UpdateDeliveryRequestRegistration.vue